export default "__VITE_ASSET__G$MgwagM__"